const CouponRoutes = {
    createCoupon: 'admin/coupons',
    deleteCoupon: 'admin/coupons/',
    getCoupons: 'admin/coupons',
    updateCoupon: 'admin/coupons',
};

export default CouponRoutes